import { Module } from 'vuex';
import type { AppState } from '../types';

export type SkuDataState = {
  skuData: Record<string, any>;
};

const state: SkuDataState = {
  skuData: {},
};

const skuDataModule: Module<SkuDataState, AppState> = {
  namespaced: true,
  state,

  mutations: {
    setSkuData(localState, data: Record<string, any>) {
      localState.skuData = { ...data };
    },
    updateSkuData(localState, data: Record<string, any>) {
      Object.assign(localState.skuData, data);
    },
    resetSkuData(localState) {
      localState.skuData = {};
    },
  },

  actions: {
    saveSkuData({ commit }, data: Record<string, any>) {
      commit('setSkuData', data);
    },
  },

  getters: {
    getSkuData: (localState) => localState.skuData,
  },
};

export default skuDataModule;
